import { CurrencyEnum } from '@spectrocoin/sc-currencies';

export enum MerchantOrderStatus {
	NEW = 'NEW',
	PENDING = 'PENDING',
	PARTIAL_PAYMENT = 'PARTIAL_PAYMENT',
	PAID = 'PAID',
	FAILED = 'FAILED',
	EXPIRED = 'EXPIRED',
	TEST_PAID = 'TEST_PAID',
	TEST_EXPIRED = 'TEST_EXPIRED',
}

export default interface MerchantOrder {
	id: string;
	orderId: string;
	payAmount: string;
	receiveAmount: string;
	payCurrencyCode: CurrencyEnum;
	payCurrencyName: string;
	payNetworkCode: string;
	payNetworkName: string;
	feeCurrencyCode: CurrencyEnum;
	receiveCurrencyCode: CurrencyEnum;
	description: string | null;
	projectName: string;
	depositAddress: string | null;
	depositMessage: string | null;
	created: string;
	validUntil: string;
	status: MerchantOrderStatus;
	successURL: string | null;
	failureURL: string | null;
}
